import { DateAdapter } from "../helpers/adapters/date/DateAdapter";
import { DatePort } from "../helpers/adapters/date/DatePort";
import { StubDateAdapter } from "../helpers/adapters/date/StubDateAdapter";

export function dateAdapterFactory(): DatePort {
  const value = localStorage.getItem("x-droople-override-date-adapter");
  return value === null ? new DateAdapter() : new StubDateAdapter(value);
}
